import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-theme-three',
  templateUrl: './theme-three.component.html',
  styleUrls: ['./theme-three.component.css']
})
export class ThemeThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
